import en from './en.json';
import nl from './nl.json';

export const dictionaryList = { en, nl };

export const languageOptions = {
  en: 'English',
  nl: 'Nederland'
};